import {CONST} from '../../../config'

export default {
    beforeDestroy() {
        this.resetMessage();
    },
    methods: {
        // [METHODS] Event : on-input
        applyRule(/*from*/v) {
            const f = this.field, r = this.rowInfo.row;
            if(f.readonly) return;
            if(r.__dirty === CONST.VAL.DIRTY.FLAG.UPDATE && !f.edit) return;
            this.checkRules(this.editValue);
        },
        resetRule() {
            this.resetMessage();
        },
        resetMessage() {
            // 1. remove message from global
            this.gridInfo.func.delCellMsg(this.rowInfo.row, this.field);
        },
        setMessage(txt) {
            // 1. set message to global
            this.gridInfo.func.addCellMsg(txt, this.rowInfo.row, this.field, 'error')
        },
        checkRules(v) {
            const rules = this.field.__rules;
            if(!rules) return;
            var res;
            rules.find(rule => {
                res = rule(v,this.rowInfo.row, this.gridInfo.caller);
                if(res===true) return false;
                this.setMessage(res);
                return true;
            })
        },
    }
}